<template>
    <div class="tutors_home">
        <HeadImg :msg="titleName" :url="imgTutors"></HeadImg>

        <div class="shilineBox">
            <div class="rLine"></div>
            <div class="cLine"></div>
        </div>

        <div class="tutors2">
            <div class="t2_cont">
                <div class="t2_item">
                    <div class="t2_left">
                        <img src="../img/师资/Group 394.png" alt="">
                        <p>教学经验</p>
                    </div>
                    <div class="t2_line"></div>
                    <div class="t2_right">
                        RoSSo的艺术导师除了高学历，更有丰富的一线教学经验。多年的教学经验带你精准攻克各类申请痛点。
                    </div>
                </div>
                <div class="t2_item">
                    <div class="t2_left">
                        <img src="../img/师资/Group 396.png" alt="">
                        <p>教学大纲</p>
                    </div>
                    <div class="t2_line"></div>
                    <div class="t2_right">
                        RoSSo各类课程大纲均来自欧美艺术院校主流专业的资深教授们深度参与编写，并不断迭代更新。
                    </div>
                </div>
                <div class="t2_item">
                    <div class="t2_left">
                        <img src="../img/师资/Group 395.png" alt="">
                        <p>师资背景</p>
                    </div>
                    <div class="t2_line"></div>
                    <div class="t2_right">
                        RoSSo各类课程覆盖的艺术专业多达23个无论你想学摄影、还是纯艺术、或是服装设计等，这里统统都有。
                    </div>
                </div>
                <div class="t2_item">
                    <div class="t2_left">
                        <img src="../img/师资/Group 397.png" alt="">
                        <p>教学质量</p>
                    </div>
                    <div class="t2_line"></div>
                    <div class="t2_right">
                        RoSSo深知，只有扎实的学术水平才能保证优异的教学质量。因此，我们只聘用毕业于世界艺术院校的研究生。
                    </div>
                </div>

            </div>
        </div>

        <div class="tutors3">
            <div class="section_title wow bounceInLeft">
                <p class="section_cn">海外大师</p>
                <p class="section_en">OVERSEA TUTORS</p>
            </div>
            <div class="t3_cont">
                <div class="swiper mySwiperT1">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide" v-for="(item, index) in tutors2Data">
                            <div class="t3_item" v-for="(item2, index2) in item" @click="tutorsDetail(item2.id)">
                                <img :src="' https://public.rossoarts.com/static/uploads/teacher/' + item2.avatar" alt="">
                                <div class="en">{{item2.school | schoolAd}}</div>
                                <p class="t3_p1 en">Prof.{{ item2.name }}</p>
                                <p class="t3_p2 cn">{{ item2.major }}</p>
                                <p class="t3_p3 cn">{{ item2.school | schoolAll}}</p>
                            </div>

                        </div>

                    </div>
                    <div class="swiper-pagination"></div>
                    <div class="swiper-button-next"></div>
                    <div class="swiper-button-prev"></div>
                </div>
            </div>
        </div>

        <div class="tutors4">
            <div class="section_title wow bounceInLeft">
                <p class="section_cn">海归导师团队</p>
                <p class="section_en">RETURNEE MENTOR TEAM</p>
            </div>
            <div class="t4_cont">
                <div class="swiper mySwiperT2">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide" v-for="(item, index) in tutors1Data">

                            <div class="t4_item" v-for="(item2, index2) in item" @click="tutorsDetail(item2.id)">
                                <div class="t4_wbox">
                                    <img :src="' https://public.rossoarts.com/static/uploads/teacher/' + item2.avatar" alt="">
                                </div>

                                <div class="en div1">{{item2.school | schoolAd}}</div>
                                <p class="t4_p1 en">{{ item2.name }}</p>
                                <p class="t4_p2 cn">{{ item2.major }}</p>
                                <p class="t4_p3 cn">{{ item2.school | schoolAll}}</p>

                            </div>

                        </div>

                    </div>
                    <div class="swiper-pagination"></div>
                    <div class="swiper-button-next"></div>
                    <div class="swiper-button-prev"></div>
                </div>
            </div>
        </div>

        <div class="tutors5">
            <div class="section_title">
                <p class="section_cn">iTUTOR导师专访</p>
                <p class="section_en">iTUTOR INTERVIEW</p>
            </div>
            <div class="t5_cont">
                <div class="swiper mySwiperT3">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide" v-for="(item, index) in artsTutor">
                            <div class="t5_item" v-for="(item2, index2) in item" @click="tutosNewsDetail(item2.id)">
                                <img :src="'https://public.rossoarts.com/static/uploads/article/' + item2.list_img" alt="">
                                <p>{{ item2.title }}</p>
                            </div>

                        </div>


                    </div>
                    <div class="swiper-pagination"></div>
                    <div class="swiper-button-next"></div>
                    <div class="swiper-button-prev"></div>
                </div>
            </div>
        </div>

        <div class="tutors6">
            <div class="section_title">
                <p class="section_cn">热门回答</p>
                <p class="section_en">POPULAR Q&A</p>
            </div>
            <div class="t6_cont">
                <img src="../img/师资/Clip path group.png" alt="" class="t6_left">
                <div class="t6_right">
                    <div v-for="(item, index) in qaData" class="t6_item" @click="t6Show(index)">
                        <div class="t6_item_show">
                            <div>Q：{{ item.question }}</div>
                            <img src="../img/师资/Group 333.png" alt="" class="t6_imgQ">
                        </div>

                        <div class="grid">
                            <div class="t6_item_hid">
                                <div style="margin-top: 20px;">A：{{ item.answer }}</div>
                                <img src="../img/师资/Group 334.png" alt="">
                            </div>
                        </div>
                    </div>
                    <div class="t6_page">

                        <el-pagination layout="prev, pager, next" :total="qaTotal" @current-change="handelPage">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>


        <!-- 最外层div -->
    </div>
</template>
<script>
import HeadImg from '@/components/HeadImg.vue'
import imgTutors from '@/img/师资/Rectangle 142.jpg'
import "../assets/css/tutors.css";
import Swiper from 'swiper/bundle'
import axios from "axios";
export default {
    components: {
        HeadImg
    },
    data() {
        return {
            imgTutors,
            titleName: {
                cname: "师资团队",
                ename: "ART TUTOR"
            },
            tutors2Data: [],
            tutors1Data: [],
            artsTutor: [],
            qaData: [],
            qaTotal: 0,
            qaPage: 1,
            flag: false,
        }
    },
    created() {
        this.getTutors2()
        this.getTutors1()
        this.getArtsNew()
        this.getQa()
    },
    filters:{
        schoolAd(val){
            // console.log(val,"teacher val");
            return val.split(",")[1]
        },
        schoolAll(val){
            return val.split(",")[0]
        },
    },
    methods: {
        tutorsDetail(val){
            console.log(val);
            this.$router.push(`/teachers/${val}.html`)
        },
        tutosNewsDetail(val){
            console.log(val);
            // window.open(`https://public.rossoarts.com/news/${val}.html`,"_blank")
            this.$router.push(`/news/${val}.html`)
        },
        t6Show(val) {
            var t6_item = document.getElementsByClassName("t6_item")
            var grid = document.getElementsByClassName("grid")
            var t6_item_show = document.getElementsByClassName("t6_item_show")
            var t6_imgQ = document.getElementsByClassName("t6_imgQ")
            // this.flag = !this.flag
            // console.log(grid[val].style.gridTemplateRows,val);
            if (grid[val].style.gridTemplateRows == "1fr") {
                // 不出
                grid[val].style.gridTemplateRows = "0fr";
                t6_item_show[val].style.backgroundColor = "#5f9df7"
                t6_item_show[val].style.border = "none"
                t6_item_show[val].style.margin = "0px"
                t6_imgQ[val].style.visibility = "visible"
            } else {
                // 出
                grid[val].style.gridTemplateRows = "1fr";
                t6_item_show[val].style.backgroundColor = "#FB6333"
                t6_item_show[val].style.border = "2px solid #000"
                t6_item_show[val].style.margin = "-2px -2px 0 -2px"
                t6_imgQ[val].style.visibility = "hidden"
                
            }
        },
        arrGroup(array, sublength) {
            let index = 0;
            let newArray = []
            while (index < array.length) {
                newArray.push(array.slice(index, index += sublength))
            }
            return newArray
        },
        getTutors2() {
            axios.get("https://public.rossoarts.com/api/v1/getFirstTeacher?category=2&limit=18").then((data) => {
                // console.log(data.data);
                // console.log(this.arrGroup(data.data,6));
                this.tutors2Data = this.arrGroup(data.data, 6)
                this.$nextTick(() => {
                    this.swiperT1()
                })
            })
        },
        getTutors1() {
            axios.get("https://public.rossoarts.com/api/v1/getFirstTeacher?category=1&limit=36").then((data) => {
                // console.log(data.data);
                // console.log(this.arrGroup(data.data, 12));
                this.tutors1Data = this.arrGroup(data.data, 12)
                this.$nextTick(() => {
                    this.swiperT2()
                })
            })
        },
        getArtsNew() {
            axios.get("https://public.rossoarts.com/api/v1/getArtsNews?category=30&limit=12&page=1").then((data) => {
                // console.log(data.data.data.data, "导师分享");
                this.artsTutor = this.arrGroup(data.data.data.data, 4)
                this.$nextTick(() => {
                    this.swiperT3()
                })
            })
        },
        getQa() {
            axios.get(`https://public.rossoarts.com/api/v1/getQa?limit=5&page=${this.qaPage}`).then((data) => {
                // console.log(data.data.data);
                this.qaData = data.data.data
                this.qaTotal = data.data.total
                // this.artsTutor = this.arrGroup(data.data.data.data, 4)
            })
        },
        handelPage(val) {
            // console.log(val);
            this.qaPage = val
            this.getQa()

            var t6_item = document.getElementsByClassName("t6_item")
            var grid = document.getElementsByClassName("grid")
            var t6_item_show = document.getElementsByClassName("t6_item_show")
            var t6_imgQ = document.getElementsByClassName("t6_imgQ")
            // this.flag = !this.flag
      
            for(var i=0;i<t6_item.length;i++){
                grid[i].style.gridTemplateRows = "0fr";
                t6_item_show[i].style.backgroundColor = "#5f9df7"
                t6_item_show[i].style.border = "none"
                t6_item_show[i].style.margin = "0px"
                t6_imgQ[i].style.visibility = "visible"
            }
          
        },
        swiperT3() {

            var swiper = new Swiper(".mySwiperT3", {
                observer: true,
                loop: true,
                pagination: {
                    clickable: true,
                    el: ".swiper-pagination",
                },
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
            });

        },
        swiperT2() {
            var swiper = new Swiper(".mySwiperT2", {
                observer: true,
                loop: true,
                pagination: {
                    clickable: true,
                    el: ".swiper-pagination",
                },
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
            });
        },
        swiperT1() {
            var swiper = new Swiper(".mySwiperT1", {
                observer: true,
                loop: true,
                pagination: {
                    clickable: true,
                    el: ".swiper-pagination",
                },
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
            });
        }

    },
    mounted() {



    }
}
</script>